module.exports = __webpack_public_path__ + "static/media/diesel-bad-big.eeed52a1.png";